import ApiService from './ApiService';
import React from 'react';
import { showModal, closeModal } from '../PageLayout/MainModal';
import { Button } from 'react-bootstrap';
import Spinner from '../PageLayout/Spinner';

class ProjectService {
  static devOpsPathProjectImage = '/documentation/homepage/project_image.png';

  static async getProjectImage(id) {
    const url = window.URL || window.webkitURL;

    const imageBlob = await ApiService.blobFetch(`project/${id}/repositoryImage`, 'GET');
    const imageUrl = url.createObjectURL(imageBlob);
    setTimeout(() => { url.revokeObjectURL(imageUrl); }, 6000);

    return imageUrl;
  }

  static archiveProjectConfirm(project, okCallback) {
    const renderModal = (stateLabel) => {
      const title = 'Archive project';
      const content = (
        <div>
          <p>
            Do you realy want to archive project {'"'}{project.name}{'"'} ?
          </p>
          <Button variant="outline-primary" onClick={() => closeModal()}>No</Button>{'\t'}
          <Button variant="primary" onClick={() => action()}>Archive{stateLabel}</Button>
        </div>
      );
      showModal(title, content, null);
    };

    const action = () => {
      renderModal(<span> <Spinner /></span>);
      okCallback();
    };
    renderModal(null);
  }

  static deleteProjectConfirm(project, okCallback) {
    const renderModal = (stateLabel) => {
      const title = 'Delete project';
      const content = (
        <div>
          <p>
            Do you realy want to delete project {'"'}{project.name}{'"'} <b>permanently</b>?<br />
            <span style={{ color: '#F00'}}>All associated cloud ressources will be <b>remove</b> for this project!</span>
          </p>
          <Button variant="outline-primary" onClick={() => closeModal()}>No</Button>{'\t'}
          <Button variant="primary" onClick={() => action()}><span style={{ color: '#F00'}}><b>DELETE</b></span>{stateLabel}</Button>
        </div>
      );
      showModal(title, content, null);
    };

    const action = () => {
      renderModal(<span> <Spinner /></span>);
      okCallback();
    };
    renderModal(null);
  }

}

export default ProjectService;
